import { Component, Inject, OnInit, AfterViewInit } from '@angular/core';
import { CommonService, FirebaseMessagingService, TaskInfoService } from '@biz2x/libraries/core-utils/utils';
import { Store } from '@ngrx/store';
import { environment } from '../environments/environment';
import { appConfig } from './+state/app-state.actions';
import { AppStateFacade } from './+state/app-state.facade';
import { take } from 'rxjs/operators';

@Component({
  selector: 'biz2x-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(
    private readonly stateFacade: AppStateFacade,
    private readonly taskInfoService: TaskInfoService,
    public store: Store,
    private common:CommonService,
    @Inject('CONSTANTS') public CONSTANTS,
    private fcmService: FirebaseMessagingService
  ) {
    this.stateFacade.init();
  }

  ngOnInit(): void {
    this.fcmService.listenForMessages();

    this.fcmService.currentMessage.subscribe(message => {
      console.log("FCM message", message)
      if (message) {
        const {title, body} = message.notification;
        new Notification(title, { body });
      }
    });
  }

  ngAfterViewInit(): void {
    const isInIframe = window.self !== window.top;
    setTimeout(() => {
      if (isInIframe) {
        document.querySelector('body').classList.remove('standalonePortal');
      } else {
        document.querySelector('body').classList.add('standalonePortal');
      }
      //get theme variable and update in app root
      this.common.theme$.subscribe(vars => {
        this.updateCSSVariables(vars);
      });   
    }, 100);
  }

  getConfiguration() {
    this.taskInfoService
      .getTaskInfo({ slug: this.CONSTANTS.SLUG.configuration })
      .subscribe((response) => {
        const configurations =
          response?.response_data?.get_configuration?.data?.data;
        this.store.dispatch(appConfig({ configurations }));
      });
  }
   updateCSSVariables(cssData:any): void {
    // console.log("cssData-->>",cssData)
    if(!cssData) return;
      const cssMap: Record<string, string> = {
      '--biz-primary-color':cssData["biz-overlay-primary-color"],
      '--biz-secondary-color':cssData["biz-overlay-secondary-color"],
      '--biz-secondary07':cssData["biz-overlay-secondary-color"],
      // Primary app & overlay fonts
      '--biz-app-fonts': cssData["biz-app-fonts"],
      '--biz-overlay-fonts': cssData["biz-overlay-fonts"],

      // Global overlay colors
      '--biz-overlay-bg-color': cssData["biz-overlay-bg-color"],
      '--biz-overlay-bg-color-rgb': cssData["biz-overlay-bg-color-rgb"] || this.hexToRgb(cssData["biz-overlay-bg-color"]),
      '--biz-overlay-large-header': cssData["biz-overlay-large-header"],

      // Primary & secondary colors
      '--biz-overlay-primary-color': cssData["biz-overlay-primary-color"],
      '--biz-overlay-primary-color-rgb': cssData["biz-overlay-primary-color-rgb"] || this.hexToRgb(cssData["biz-overlay-primary-color"]),
      '--biz-primary-color-rgb': cssData["biz-overlay-primary-color-rgb"] || this.hexToRgb(cssData["biz-overlay-primary-color"]),
      '--biz-overlay-secondary-color': cssData["biz-overlay-secondary-color"],
      '--biz-overlay-secondary-color-rbg': this.hexToRgb(cssData["biz-overlay-secondary-color"]),

      // Admin variants (mirror of overlay in this case)
      '--biz-admin-overlay-bg-color': cssData["biz-overlay-bg-color"],
      '--biz-admin-overlay-bg-color-rgb': cssData["biz-overlay-bg-color-rgb"] || this.hexToRgb(cssData["biz-overlay-bg-color"]),
      '--biz-admin-overlay-primary-color': cssData["biz-overlay-primary-color"],
      '--biz-admin-overlay-primary-color-rgb': cssData["biz-overlay-primary-color-rgb"] || this.hexToRgb(cssData["biz-overlay-primary-color"]),
      '--biz-admin-overlay-secondary-color': cssData["biz-overlay-secondary-color"],
      '--biz-admin-overlay-secondary-color-rbg': this.hexToRgb(cssData["biz-overlay-secondary-color"]),
      '--biz-admin-overlay-large-header': cssData["biz-overlay-large-header"],
      '--biz-admin-overlay-fonts': cssData["biz-overlay-fonts"],
      '--biz-admin-app-fonts': cssData["biz-app-fonts"]
    };

    if(cssMap['--biz-overlay-primary-color'] && localStorage.getItem('destination_url') && localStorage.getItem('destination_url') !== 'undefined') window.parent.postMessage({type: 'primaryColor',"primaryColor": cssMap['--biz-overlay-primary-color']}, localStorage.getItem('destination_url'));
    Object.entries(cssMap)?.forEach(([key, val]) => {
      if(val) document.documentElement.style.setProperty(key, val,'important');
    });

  }

  hexToRgb(hex: string): string {
    if (!hex) return '';
    hex = hex.replace(/^#/, '');
    if (hex.length === 3) hex = hex.split('').map(c => c + c).join('');
    const bigint = parseInt(hex, 16);
    return `${(bigint >> 16) & 255}, ${(bigint >> 8) & 255}, ${bigint & 255}`;
  }
}
